import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MasterService } from "@frontend/app/serivces/master.service";
import { Cls_MenuList } from "@frontend/app/models/master";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "@frontend/app/serivces/toastr.service";

import { SVG_ICONS } from "@frontend/app/models/icons";
import { OnlyLattersDirective } from "@frontend/app/directives/only-letters.directive";
import { AsteriskMessageDirective } from "@frontend/app/directives/asterikmessage.directive";

@Component({
  selector: "app-add-menu",
  imports: [CommonModule, FormsModule, OnlyLattersDirective, AsteriskMessageDirective],
  templateUrl: "./add-menu.component.html",
  styleUrl: "./add-menu.component.scss",
})
export class AddMenuComponent implements OnInit {
  private mastService = inject(MasterService);
  private toastrService = inject(ToastrService);
  ErrorMsg: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AddMenuComponent>) {
  }

  ngOnInit() {
    if (this.data.ParentMenuID) {
      this.ParentMenuID = this.data.ParentMenuID;
      this.getMenuByID();
    }
    if (this.data.menuId) {
      this.menuID = this.data.menuId;
      this.getMenuByID();
    }
  }

  //#region variables
  menuList = new Cls_MenuList();
  menuID = 0;
  ParentMenuID = 0;
  readonly SVG_ICONS = SVG_ICONS;
  //#endregion

  validateStep(): boolean {
    this.ErrorMsg = [];

    const requiredFields: { key: keyof Cls_MenuList; label: string }[] = [
      { key: "MenuName", label: "Menu Name" },
      { key: "RouterPath", label: "Router Path" },
      // { key: "iorder", label: "Order" },
    ];

    for (const field of requiredFields) {
      const value = this.menuList[field.key] as any;
      if (value == null || (typeof value === "string" && !value.trim())) {
        this.ErrorMsg.push(`${field.label}`);
        continue;
      }
    }

    const isValid = this.ErrorMsg.length === 0;
    if (!isValid) {
      this.toastrService.error("Please fill in all required fields", "Validation Error");
    }
    return isValid;
  }

  onSubmit() {
    if (!this.validateStep()) return;
    const tempModal = new Cls_MenuList();
    tempModal.MenuID = this.menuList.MenuID ? this.menuList.MenuID : 0;
    tempModal.MenuName = this.menuList.MenuName;
    tempModal.ParentMenuID = this.ParentMenuID || 0;
    tempModal.MenuCaption = this.menuList.MenuCaption;
    tempModal.RouterPath = this.menuList.RouterPath;
    tempModal.iorder = this.menuList.iorder;
    tempModal.svg_default = this.menuList.svg_default;
    tempModal.IconName = this.menuList.IconName;
    if (this.menuList.MenuID && this.menuList.MenuID > 0) {
      this.mastService.updateMenu(tempModal, this.menuList.MenuID).subscribe(res => {
        this.toastrService.success("Menu updated successfully");
        this.dialogRef.close(res);
      });
    } else {
      this.mastService.addMenu(tempModal).subscribe(res => {
        this.toastrService.success("Menu added successfully");
        this.dialogRef.close(res);
      });
    }
  }

  getMenuByID() {
    this.mastService.GetMenuByID(this.ParentMenuID || this.menuID).subscribe(res => {
      const { Table } = res;
      this.menuList = Table;
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
